import CaliberNote from './CaliberNote';

export default (props) => <CaliberNote {...props} />;
